import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './AdvisorProfile.module.scss';
import {Container, Row, Col} from "react-bootstrap";
import * as Components from './components/index';
import * as functions from "../../helper/functions";
import * as advisorActions from "../../redux/action/advisor.action";
import * as propertyActions from "../../redux/action/property.action";

class AdvisorProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      advisor: {}
    }
  }

  async componentDidMount() {
    const { fetchAdvisor, fetchAdvisorProperties } = this.props;
    const paths = functions.getFilterName();
    if (paths.length === 2) {
      fetchAdvisorProperties(paths[1]);
      const advisor = await fetchAdvisor(paths[1]);
      this.setState({advisor});
    }
  }

  render() {
    const { advisor } = this.state;
    const { advisorProperties } = this.props;

    return (
      <Container fluid className={`p-0 ${style.profile_container}`}>
        <Row className={'m-0 no-gutters'}>
          <Col sm={5} xl={3} className={style.sidebar}>
            <Components.GeneralInfo advisor={advisor} />
            <Components.MoreInfo advisor={advisor} />
            <Components.ContactMe advisor={advisor} />
          </Col>
          <Col sm={7} xl={9}>
            <Components.MapProperties properties={advisorProperties} />
            {
              advisorProperties && !!advisorProperties.length && (
                <Components.Properties properties={advisorProperties} />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  advisorProperties: state.property.advisorProperties
});

const mapDispatchToProps = (dispatch) => ({
  fetchAdvisor: (id) => dispatch(advisorActions.fetchAdvisor(id)),
  fetchAdvisorProperties: (advisorId) => dispatch(propertyActions.fetchAdvisorProperties(advisorId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdvisorProfile));
